import React, { useState } from "react";
import "./userRegister.css";
import { useNavigate, Link } from "react-router-dom";

// Split-screen login layout using existing column classnames

const UserLogin = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            alert("Por favor, introduce tu correo y contraseña.");
            return;
        }

        try {
            setSubmitting(true);
            const response = await fetch("https://nodeapi.juan1ondonolinks.com/api/users/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    password,
                }),
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Error response:", errorText);
                alert("Credenciales inválidas o error al iniciar sesión.");
                return;
            }

            const data = await response.json();
            // Persist JWT and a simple auth flag for the protected routes
            localStorage.setItem("cliperos_token", data.token);
            localStorage.setItem("cliperos_auth", "true");
            if (data.user) {
                localStorage.setItem("cliperos_user", JSON.stringify(data.user));
                if (data.user.nombre) {
                    localStorage.setItem("cliperos_user_name", data.user.nombre);
                }
            }

            // Navigate to dashboard after successful login
            navigate("/dashboard");
        } catch (err) {
            console.error(err);
            alert("No se pudo conectar con el servidor.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="two-column-container">
            {/* Branding zone */}
            <div className="left-column">
                <div className="left-column-inner">
                    <div className="logo-play">
                        <div className="logo-play-triangle" />
                    </div>
                    <div className="logo-text">CLIPEROS</div>
                </div>
            </div>

            {/* Interaction zone */}
            <div className="right-column">
                <div className="form-shell">
                    {/* Header logo + title */}
                    <div className="form-header-logo">
                        <div
                            className="logo-play"
                            style={{ boxShadow: "0 8px 16px rgba(255, 94, 125, 0.35)" }}
                        >
                            <div className="logo-play-triangle" />
                        </div>
                        <div className="logo-text" style={{ fontSize: 22 }}>
                            CLIPEROS
                        </div>
                    </div>

                    <h1 className="form-title">
                        Inicia sesión en
                        <br />
                        tu cuenta de Cliperos.
                    </h1>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="email" className="form-label">
                                Introduce tu correo electrónico
                            </label>
                            <input
                                id="email"
                                type="email"
                                className="form-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group password-wrapper">
                            <label htmlFor="password" className="form-label">
                                Introduce tu contraseña
                            </label>
                            <input
                                id="password"
                                type={showPassword ? "text" : "password"}
                                className="form-input form-input-composite"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword((v) => !v)}
                            >
                                {showPassword ? "🙈" : "👁"}
                            </button>
                        </div>

                        <button type="submit" className="cta-button" disabled={submitting}>
                            {submitting ? "Entrando..." : "Acceder a mi cuenta"}
                        </button>
                    </form>

                    <div className="form-footer" style={{ marginTop: 10 }}>
                        ¿Olvidaste tu contraseña? Haz clic aquí.
                    </div>

                    <div className="form-footer" style={{ marginTop: 24 }}>
                        <hr style={{ border: 0, borderTop: "1px solid #e5e7eb", width: "100%" }} />
                        <div style={{ marginTop: 12, marginBottom: 12 }}>•</div>
                        <hr style={{ border: 0, borderTop: "1px solid #e5e7eb", width: "100%" }} />
                    </div>

                    

                    <div className="form-footer" style={{ marginTop: 24 }}>
                        ¿Aún no tienes una cuenta de Cliperos? <Link to="/register">Registro</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserLogin;
